<template>
  <div :class="['col', { visible: isVisible }]" v-observe-visibility="{callback: updateVisible, once: true, throttle: 400}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Update',
  data: function () {
    return {
      isVisible: false
    }
  },
  methods: {
    updateVisible: function(isVisible) {
      this.isVisible = isVisible
    }
  }
}
</script>

<style scoped lang="scss">
div.col {
  position: relative;
  left: 50px;
  opacity: 0;
  transition: opacity 250ms, left 250ms;

  &.visible {
    opacity: 1;
    left: 0;
  }
}
</style>
